<template>
  <carousel-wrapper
    :element-key="elementKey"
    :element-data="elementData"
    :display-name="displayname"
    icon-name="icons perspectives-box" 
    :children="elementData.perspective" />
</template>

<script>
import CarouselWrapper from "@/components/card/CarouselWrapper";

export default {
  name: "PerspectivesBox",
  props: {
    elementKey: String,
    elementData: Object,
  },
  components: {
    CarouselWrapper,
  },
  computed: {
    displayname() {
      return "Perspectives";
    },
  }, 
};
</script>

<scss lang="scss" scoped>

</scss>
